<script setup lang="ts">
import { BlockSliderFullTexts } from '~/lib/services/content/content.blocks.dtos'

defineProps<{
  block: BlockSliderFullTexts
}>()

const isMobile = inject('isMobile')
</script>

<template>
  <section class="mt-4 flex px-14 pb-4 pt-14">
    <SliderCustom :slides="1" show-bullet class="block-slider-full w-full">
      <SwiperSlide v-for="slide in block.sliderFullTexts" :key="slide.id">
        <figure class="flex flex-col md:h-[272px] md:w-full md:flex-row-reverse">
          <img
            class="h-[360px] object-none md:h-auto md:w-[272px] md:object-cover lg:mr-[150px]"
            :src="isMobile ? slide.imageMobile.url : slide.imageDesktop.url"
            :alt="
              (isMobile ? slide.imageMobile.alternativeText : slide.imageDesktop.alternativeText) ||
              undefined
            "
          />
          <div
            class="h-46 mb-12 flex flex-col gap-4 pl-4 pr-[26px] pt-6 lg:m-auto lg:h-full lg:w-full lg:p-12"
          >
            <header>
              <h2 class="text-[32px] font-bold leading-9 tracking-[-0.15px]">{{ slide.title }}</h2>
            </header>
            <section>
              <p class="text-sm leading-4 tracking-[-0.15px]">{{ slide.content }}</p>
            </section>
          </div>
        </figure>
      </SwiperSlide>
    </SliderCustom>
  </section>
</template>

<style>
.block-slider-full .swiper-pagination-bullets {
  @apply mb-2 pl-4 text-start lg:pb-8 lg:pl-12;
}
</style>
